import * as React from "react";
import { Mutation } from "react-apollo";
import { Form, Label, FormGroup, Input, Button } from "reactstrap";

// GraphQL
import UpdateSiteMutation from "../../GraphQL/Mutations/UpdateSite";
import GetCompanySites from "../../GraphQL/Queries/GetCompanySites";

// Presentation/UI
import Loader from "../../Components/Loader";

// Theme
import { Colors } from "../../Themes";

interface IProps {
  companyId: any;
  site: any;
  closeModal(): void;
  notification(message: string): void;
}

interface IState {
  id: string;
  name: string;
  region: string;
  physicalAddress: string;
  loading: boolean;
  error: null | string;
}

class EditSiteForm extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      id: props.site.id,
      name: props.site.name,
      region: props.site.region,
      physicalAddress: props.site.physicalAddress,
      loading: false,
      error: null
    };
  }

  // Handle change
  handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const { name, value }: { name: string; value: string } = e.currentTarget;

    switch (name) {
      case "siteName":
        this.setState({ name: value });
        break;
      case "region":
        this.setState({ region: value });
        break;
      case "physicalAddress":
        this.setState({ physicalAddress: value });
        break;
      default:
        break;
    }
  };

  validateForm = (): boolean => {
    // Check for undefined or empty infput fields
    if (!this.state.name) {
      this.setError("Please fill in the name of the site");
      return false;
    }
    return true;
  };

  // Error
  setError = (error: string): void => {
    this.setState(
      {
        error
      },
      () => {
        setTimeout(() => {
          this.setState({ error: null });
        }, 3000);
      }
    );
  };

  render() {
    const { id, name, region, physicalAddress } = this.state;
    const { companyId, closeModal, notification } = this.props;
    return (
      <Mutation<{}, {}> mutation={UpdateSiteMutation}>
        {(updateSite, { loading, error }) => (
          <Form
            onSubmit={e => {
              e.preventDefault();
              if (this.validateForm()) {
                this.setState({ loading: true });

                updateSite({
                  variables: {
                    id,
                    name,
                    region,
                    physicalAddress
                  },
                  refetchQueries: [
                    {
                      query: GetCompanySites,
                      variables: { id: companyId }
                    }
                  ]
                })
                  .then(res => {
                    this.setState({ loading: false });

                    closeModal();
                    notification("Site updated successfully");
                  })
                  .catch(err => {
                    this.setState({ loading: false });
                  });
              }
            }}
          >
            <FormGroup>
              <Label for="siteName">Site Name</Label>
              <Input
                type="text"
                name="siteName"
                value={name}
                id="siteName"
                placeholder="Site name"
                onChange={this.handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label for="region">Region</Label>
              <Input
                type="text"
                name="region"
                value={region}
                id="region"
                placeholder="Region"
                onChange={this.handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label for="physicalAddress">Physical Address</Label>
              <Input
                type="text"
                name="physicalAddress"
                value={physicalAddress}
                id="physicalAddress"
                placeholder="Physical address"
                onChange={this.handleChange}
              />
            </FormGroup>
            <br />
            <FormGroup>
              <Button>
                {!this.state.loading ? <span>Update</span> : <Loader />}
              </Button>
            </FormGroup>
            {this.state.error && (
              <p style={{ textAlign: "center", color: Colors.error }}>
                {this.state.error}
              </p>
            )}
          </Form>
        )}
      </Mutation>
    );
  }
}

export default EditSiteForm;



// WEBPACK FOOTER //
// ./src/Containers/Sites/EditSiteForm.tsx